import { DatePipe } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { LocaleString } from "../translate/localeString.model";
import { format } from "date-fns";

@Injectable({
    providedIn: 'root'
})
export class LocalizeService {

    private translate = inject(TranslocoService);

    transform(value: LocaleString | string): string {
        if (!value) {
            return '';
        }

        const lang = this.translate.getActiveLang();
        const defaultLang = this.translate.getDefaultLang();

        if (Array.isArray(value)) {
            const langString = value.find((v: { locale: string; text: string }) => v.locale === lang);
            if (langString) {
                return langString.text;
            } else {
                return '';
            }
        } else if (typeof value === 'string') {
            return value;
        } else {
            return value[lang] ?? value[defaultLang] ?? value[Object.keys(value)[0]] ?? '';
        }
    }

    transformDate(value: string | number | Date, dateFormat: string = 'mediumDate'): string {
        const datePipe = new DatePipe(this.translate.getActiveLang());
        const timeZoneOffset = format(value ? new Date(value) : new Date(), 'x');
        return datePipe.transform(value, dateFormat, timeZoneOffset);
    }

    transformTimezoneDate(date: string | number | Date) {
        const datePipe = new DatePipe(this.translate.getActiveLang());
        const timeZoneOffset = format(date ? new Date(date): new Date(), 'x');
        return datePipe.transform(date, 'H:mm', timeZoneOffset);
    }
}